import {
  Box,
  Chip,
  createStyles,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { makeStyles, withStyles } from "@material-ui/styles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import LOADING from "assets/img/loading.gif";
import { setFilterListExam } from "features/Admin/pages/ManagerTest/managerExamListSlice";
import moment from "moment";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { dateTimeToFormatHHMM, dateTimeToFormatYYYY } from "utils/dateTimeFormat";
import Timeout from "./components/Timeout";
import {
  fetchListExamStudent,
  SelectFilterListExamStudent,
  SelectListExamStudent,
  selectLoadingListExamStudent,
} from "./listExamStudentSlice";
import EmptyComponent from "components/Empty";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import ScheduleIcon from "@material-ui/icons/Schedule";
import AlarmIcon from "@material-ui/icons/Alarm";

export default function ListExamStudent() {
  const useStyles = makeStyles((theme: Theme) => ({
    container: {
      padding: "30px 24px",
      maxWidth: 1400,
      margin: "0 auto",
      overflow: "hidden",
      [theme.breakpoints?.down("md")]: {
        padding: "20px 16px",
      },
      [theme.breakpoints?.down("sm")]: {
        padding: "16px 10px",
      },
    },
    headerBanner: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 24,
      flexWrap: "wrap",
      gap: 16,
    },
    headerTitleGroup: {
      display: "flex",
      alignItems: "center",
      gap: 14,
    },
    headerIconPill: {
      width: 48,
      height: 48,
      borderRadius: 14,
      background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#FFFFFF",
      boxShadow: "0 6px 18px rgba(5, 150, 105, 0.3)",
    },
    title: {
      color: "#0F172A",
      fontSize: "1.35rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
      [theme.breakpoints?.down("sm")]: {
        fontSize: "1.1rem",
      },
    },
    subtitle: {
      fontSize: "0.85rem",
      color: "#64748B",
      fontWeight: 500,
    },
    summaryGrid: {
      marginBottom: 40,
    },
    summaryCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 18,
      padding: "12px 20px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.04)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 14px 28px rgba(0, 0, 0, 0.08)",
      },
    },
    loading: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      "& >img": {
        width: 100,
        height: 100,
      },
    },
    container_table: {
      borderRadius: 20,
      boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
      border: "1px solid #E2E8F0",
      overflowX: "auto",
      "& .MuiTable-root": {
        minWidth: 700,
      },
      "& .MuiTableRow-root:nth-of-type(even)": {
        backgroundColor: "#F8FAFC",
      },
    },
    rowClickable: {
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9 !important",
      },
    },
    mobileCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: "16px 18px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
      transition: "all 0.25s ease",
      "&:active": {
        transform: "scale(0.98)",
        backgroundColor: "#F8FAFC",
      },
    },
  }));

  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
        color: "#FFFFFF",
        fontSize: 13,
        fontWeight: 800,
        letterSpacing: "0.03em",
        borderRight: "1px solid rgba(255, 255, 255, 0.1)",
        borderBottom: "none",
        textTransform: "uppercase",
        [theme.breakpoints?.down("sm")]: {
          fontSize: 10,
          padding: "10px 6px",
        },
      },
      body: {
        padding: "14px 16px",
        fontSize: 13,
        fontWeight: 500,
        color: "#1E293B",
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        [theme.breakpoints?.down("sm")]: {
          fontSize: 10,
          padding: "10px 6px",
        },
      },
    })
  )(TableCell);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const listTest = useAppSelector(SelectListExamStudent);
  const loading = useAppSelector(selectLoadingListExamStudent);
  const filter = useAppSelector(SelectFilterListExamStudent);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

  useEffect(() => {
    dispatch(
      fetchListExamStudent({
        ...filter,
        fromDate: moment.utc().startOf('day').subtract(1, 'day').add(17, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      })
    );
  }, [dispatch, filter]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filter,
        page: page - 1,
      })
    );
  };

  const isExamClickable = (exam: any) => {
    if (!exam || !exam.startDate) return false;
    const currentMs = Date.now();
    const startMs = new Date(exam.startDate).getTime();
    const examEndDate = exam.endDate;
    const endMs = examEndDate
      ? new Date(examEndDate).getTime()
      : startMs + 30 * 24 * 60 * 60 * 1000;
    return currentMs <= endMs;
  };

  const handleRowClick = (exam: any) => {
    if (isExamClickable(exam)) {
      navigate(`/exam/${exam?.id}`, {
        state: {
          id: exam?.id,
          startDate: exam?.startDate,
          examTitle: exam?.title,
          prize: exam?.prize,
        },
      });
    }
  };

  const totalExams = listTest?.basicExamResponses?.content?.length || 0;

  return loading ? (
    <Box className={classes.loading}>
      <img src={LOADING} alt="LOADING" />
    </Box>
  ) : (
    <Box className={classes.container}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Box className={classes.headerTitleGroup}>
          <Box className={classes.headerIconPill}>
            <EventAvailableIcon style={{ fontSize: 26 }} />
          </Box>
          <Box>
            <Typography className={classes.title}>
              {t("listexam.lichkiemtrasaptoi")}
            </Typography>
            <Typography className={classes.subtitle}>
              Danh sách các bài thi chuẩn bị diễn ra, đếm ngược thời gian và làm bài
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Summary Stat Cards */}
      {totalExams > 0 && (
        <Grid container spacing={isMobile ? 2 : 3} alignItems="stretch" className={classes.summaryGrid}>
          <Grid item xs={12} sm={6}>
            <Box
              className={classes.summaryCard}
              style={{
                background: "linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)",
                borderColor: "#A7F3D0",
                height: "100%",
                minHeight: 80,
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontSize: "0.775rem",
                    color: "#047857",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    marginBottom: 6,
                  }}
                >
                  SỐ BÀI THI SẮP DIỄN RA
                </Typography>
                <Box style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                  <Typography
                    style={{
                      fontSize: "2.0rem",
                      fontWeight: 900,
                      color: "#059669",
                      lineHeight: 1,
                    }}
                  >
                    {totalExams}
                  </Typography>
                  <Typography style={{ fontSize: "0.95rem", fontWeight: 700, color: "#10B981" }}>
                    bài thi chuẩn bị
                  </Typography>
                </Box>
              </Box>
              <Box style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                <AlarmIcon style={{ color: "#059669", fontSize: 32 }} />
                <Chip
                  label="Đang đếm ngược"
                  size="small"
                  style={{
                    backgroundColor: "#D1FAE5",
                    color: "#047857",
                    fontWeight: 800,
                    border: "1px solid #6EE7B7",
                  }}
                />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              className={classes.summaryCard}
              style={{
                background: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)",
                borderColor: "#BFDBFE",
                height: "100%",
                minHeight: 80,
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontSize: "0.775rem",
                    color: "#1D4ED8",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    marginBottom: 6,
                  }}
                >
                  THỜI GIAN MỞ CỔNG THI
                </Typography>
                <Box style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                  <Typography
                    style={{
                      fontSize: "2.0rem",
                      fontWeight: 900,
                      color: "#2563EB",
                      lineHeight: 1,
                    }}
                  >
                    15
                  </Typography>
                  <Typography style={{ fontSize: "0.95rem", fontWeight: 700, color: "#3B82F6" }}>
                    phút trước giờ thi
                  </Typography>
                </Box>
              </Box>
              <Box style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8 }}>
                <ScheduleIcon style={{ color: "#2563EB", fontSize: 32 }} />
                <Chip
                  label="Mở nút tự động"
                  size="small"
                  style={{
                    backgroundColor: "#DBEAFE",
                    color: "#1D4ED8",
                    fontWeight: 800,
                    border: "1px solid #93C5FD",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {/* Table Section */}
      <Box>
        {listTest?.basicExamResponses?.content?.length > 0 ? (
          isMobile ? (
            <Box style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {listTest?.basicExamResponses?.content?.map((exam: any, index: number) => {
                const clickable = isExamClickable(exam);
                return (
                  <Box
                    key={exam.id}
                    onClick={() => handleRowClick(exam)}
                    className={classes.mobileCard}
                    style={{
                      cursor: clickable ? "pointer" : "default",
                    }}
                  >
                    {/* Top Row: Date/Time & Badge */}
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                      <Box style={{ display: "flex", alignItems: "center", gap: 6, color: "#2563EB" }}>
                        <ScheduleIcon style={{ fontSize: 16 }} />
                        <Typography style={{ fontWeight: 800, fontSize: "0.85rem" }}>
                          {dateTimeToFormatHHMM(exam.startDate)} - {dateTimeToFormatYYYY(exam.startDate)}
                        </Typography>
                      </Box>
                      <Timeout exam={exam} isMobile={isMobile} />
                    </Box>

                    {/* Middle Row: Exam Title */}
                    <Typography style={{ fontWeight: 800, color: "#1E293B", fontSize: "1.0rem", marginBottom: 12 }}>
                      {exam?.title}
                    </Typography>

                    {/* Bottom Row: Prize & Index */}
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 10, borderTop: "1px solid #F1F5F9" }}>
                      <Box>
                        {exam?.prize?.name ? (
                          <Box style={{ display: "flex", alignItems: "center", gap: 4, color: "#D97706" }}>
                            <CardGiftcardIcon style={{ fontSize: 16 }} />
                            <Typography style={{ fontWeight: 700, fontSize: "0.8rem" }}>
                              {exam.prize.name}
                            </Typography>
                          </Box>
                        ) : (
                          <Typography style={{ color: "#94A3B8", fontSize: "0.8rem" }}>Không có phần thưởng</Typography>
                        )}
                      </Box>
                      <Typography style={{ fontSize: "0.75rem", fontWeight: 700, color: "#64748B" }}>
                        #{listTest?.basicExamResponses?.size * listTest?.basicExamResponses?.number + index + 1}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <TableContainer component={Paper} className={classes.container_table}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width="70px">
                      {t("listexam.stt")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="130px">
                      {t("listexam.ngaythi")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="110px">
                      {t("listexam.giothi")}
                    </StyledTableCell>
                    <StyledTableCell align="left">{t("listexam.tieudebaithi")}</StyledTableCell>
                    <StyledTableCell align="center" width="180px">
                      {t("listexam.phanthuong")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="180px">
                      {t("listexam.thoigian")}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {listTest?.basicExamResponses?.content?.map((exam: any, index: number) => {
                    const clickable = isExamClickable(exam);
                    return (
                      <TableRow
                        key={exam.id}
                        onClick={() => handleRowClick(exam)}
                        className={clickable ? classes.rowClickable : ""}
                      >
                        <StyledTableCell align="center" style={{ fontWeight: 700, color: "#64748B" }}>
                          {listTest?.basicExamResponses?.size * listTest?.basicExamResponses?.number +
                            index +
                            1}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Typography style={{ fontWeight: 700, color: "#0F172A", fontSize: "0.9rem" }}>
                            {dateTimeToFormatYYYY(exam.startDate)}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Typography style={{ fontWeight: 800, color: "#2563EB", fontSize: "0.9rem" }}>
                            {dateTimeToFormatHHMM(exam.startDate)}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="left" style={{ fontWeight: 800, color: "#0F172A" }}>
                          <Typography style={{ fontWeight: 800, color: "#1E293B", fontSize: "0.95rem" }}>
                            {exam?.title}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="center" style={{ color: "#D97706", fontWeight: 700 }}>
                          {exam?.prize?.name ? (
                            <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                              <CardGiftcardIcon style={{ fontSize: 18, color: "#D97706" }} />
                              {exam.prize.name}
                            </Box>
                          ) : (
                            "-"
                          )}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Timeout exam={exam} isMobile={isMobile} />
                        </StyledTableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          <Box py={4}>
            <EmptyComponent isBorder={false} description={t("listexam.chuacobaikiemtra")} />
          </Box>
        )}

        {listTest?.basicExamResponses?.totalPages > 1 && (
          <Box mt={3} display="flex" justifyContent="center" mb={3}>
            <Pagination
              count={Math.ceil(
                listTest?.basicExamResponses?.totalElements / listTest?.basicExamResponses?.size
              )}
              page={listTest?.basicExamResponses?.number + 1}
              variant="outlined"
              color="primary"
              shape="rounded"
              onChange={(e, page) => handleChangePage(page)}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
